import React, { FC } from "react";
import { Stack, SxProps, Typography } from "@mui/material";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";
import Markdown from "@components/Markdown";

interface Props {
  content: string;
  containerSx?: SxProps;
  textSx?: SxProps;
}

const Paragraph: FC<Props> = ({ content, containerSx = {}, textSx = {} }) => {
  return (
    <Stack mb={3} sx={{ ...containerSx }}>
      <Typography
        variant="body1"
        component="span"
        sx={{
          fontSize: "16px",
          lineHeight: "24px",
          fontWeight: "300",
          color: Colors.TextDark,
          "& p:not(:last-child)": {
            margin: "0 0 24px 0",
          },
          "& p:last-child": {
            margin: "0",
          },
          "& ul, & ol": {
            margin: "24px 0",
            padding: "0 0 0 24px",
          },
          "& ul:last-child, & ol:last-child": {
            margin: "24px 0 0 0",
          },
          "& ol ul:last-child, & ul ul:last-child": {
            margin: "12px 0",
          },
          "& li": {
            margin: "0",
          },
          "& li p:not(:last-child)": {
            margin: "0",
          },
          ...textSx,
        }}
      >
        <Markdown content={content} />
      </Typography>
    </Stack>
  );
};

export default Paragraph;
